module.exports = __webpack_public_path__ + "img/photo-0061.d3e0702a.jpg";